module.exports = "<p>\r\n  environment works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/environment/environment.component.html
// module id = ./src/app/pages/environment/environment.component.html
// module chunks = main